import sticky from './sticky'
import './fontawesome-all.js';
import socialSlider from './slider'

export default {
    init() {
        // JavaScript to be fired on all pages

        let self = this
        this.socialSlider()
        self.waypointsInView()
        window.loaded.then(() => {

            $('#page-loader').delay(1500).fadeOut()
            $('.slick-slider').addClass('slick-loaded')

            setTimeout(() => {
                $('#main-header').addClass('will-change')
                $('#main-header').removeClass('initial-hide')
                $('#main-header').removeClass('will-change')

            }, 500);

            setTimeout(() => {
                $('.logo img').removeClass('default')
                $('#menu-main-menu-1').removeClass('default')
                $('.shop-link').removeClass('default')
            }, 900);

            setTimeout(() => {
                $('.spark-logo img').removeClass('default')
            }, 1000);

            setTimeout(() => {
                $('.row-inner-reveal').removeClass('initial-load')
                $('.banner-overlay').addClass('will-change')

                $('.banner-overlay').removeClass('initial-load')
                $('.banner-overlay').removeClass('will-change')
            }, 2000);

            setTimeout(() => {
                // $('.logo').addClass('reveal')
                $('.banner-overlay').addClass('notransition')
            }, 4000);

            setTimeout(() => {
                // $('.logo').removeClass('reveal')
            }, 7000);

        })

        if ($('.offcanvas-toggle').length){
            $('.offcanvas-toggle').click( function(e){
                e.preventDefault()
                $('#main-header').toggleClass('canvas-open')
                self.offcanvasToggle()
            })
        }

        $('#mobile-nav').click(function(e){
            e.preventDefault()
            $(this).toggleClass('open');
            $('#offcanvas').toggleClass('open');
            $('#main-header').toggleClass('canvas-open')
        });

        $('.scroll-element').click(function(e){
            console.log('clicked');
            e.preventDefault()
            $('html,body').animate({
                scrollTop: $(".banner-lower").offset().top
            });
        });

        $('.logo').click(function(e){
            location.href = "/";
        });

        $('#back-to-top').click(function(){
            window.scroll({top: 0, behavior: "smooth"})
        });
        $( "#posts-changer" ).selectmenu({
            change: function (event, data) {

              var selection = $(this).val();

              $('.news-tab__tab-item').removeClass('is-visible');
              // imagecontainer.dataset.selected = "";

              setTimeout(() => {
                  $('#' + selection).addClass('is-visible')

              }, 1500);

            }
        });
        this.ifIE()

        sticky.init()

    },
    offcanvasToggle() {

        $('body').toggleClass('offcanvas-open')

    },
    detectLineWidth(){
        const path = document.querySelector('#pictorial-header .line-animate-2');
        const length = path.getTotalLength()
        console.log(length)
    },
    scrollMagicBanner(){

    },
    waypointsInView() {

        var $waypoints = $('.iv-wp');

        if ($waypoints.length){
            $waypoints.each(function() {

                new Waypoint.Inview({
                    element: this,
                    enter: function(direction) {
                          // $("#div").removeClass("error");
                          $(this.element).addClass('el-iv');
                    },
                });

                // new Waypoint({
                //     element: this,
                //     handler: function(direction) {
                //         $(this.element).addClass('el-iv');
                //     },
                //     offset: 20
                // });

            });
        }

    },
    socialSlider(){

    const $socialSlider = $('.social-slider')

        // slick slider initiation
    if ($socialSlider.length) {
          $socialSlider.slick({
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
          })
    }


    },
    ifIE(){

        if ( !Modernizr.objectfit ) {
            $('.gallery-image').each(function () {
                var $container = $(this),
                    $img = $container.find('img'),
                    $imgUrl = $img.attr('srcset');

                if ($imgUrl) {
                    $container
                        .css('backgroundImage', 'url(' + $imgUrl + ')')
                        .addClass('compat-object-fit');
                }
            });
        }

    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js